// This file was automatically generated from print.currentMedsSummary.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.currentMedsSummary');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');
goog.require('el8.template.print.refPanel.meds');
goog.require('el8.template.ptdata.ptAllergies');
goog.require('el8.template.ptdata.ptIntolerances');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.currentMedsSummary.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  el8.template.print.currentAsOf(opt_data, output);
  output.append('<h1 class="documentTitle">Current Medications</h1>');
  el8.template.print.patientDemog(soy.$$augmentData(opt_data, {phrase: 'Seen', physicianName: opt_data.prescribingPhysician.name}), output);
  output.append('<h4>Current Prescription Meds</h4>');
  if (opt_data.permRxThreads.length) {
    output.append('<ol class="numberedList">');
    el8.template.print.refPanel.meds.permList({threads: opt_data.permRxThreads}, output);
    output.append('</ol>');
  } else {
    output.append('<p>No prescription medications currently taken.</p>');
  }
  output.append('<h4>Current OTC Meds</h4>');
  if (opt_data.permOtcThreads.length) {
    output.append('<ol class="numberedList">');
    el8.template.print.refPanel.meds.permList({threads: opt_data.permOtcThreads}, output);
    output.append('</ol>');
  } else {
    output.append('<p>No OTC medications currently taken.</p>');
  }
  if (opt_data.ptAllergies.items.length) {
    output.append('<h4>Allergies</h4><ul class="list">');
    var paList12489 = opt_data.ptAllergies.items;
    var paListLen12489 = paList12489.length;
    for (var paIndex12489 = 0; paIndex12489 < paListLen12489; paIndex12489++) {
      var paData12489 = paList12489[paIndex12489];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.ptAllergies.summary(paData12489, output);
      output.append('</li>');
    }
    output.append('</ul>');
  } else if (opt_data.ptAllergies.isDocumented) {
    output.append('<h4>Allergies</h4><p>');
    el8.template.ptdata.ptAllergies.documentedAsNoneSummary(null, output);
    output.append('</p>');
  }
  if (opt_data.ptIntols.items.length) {
    output.append('<h4>Drug Intolerances</h4><ul class="list">');
    var piList12502 = opt_data.ptIntols.items;
    var piListLen12502 = piList12502.length;
    for (var piIndex12502 = 0; piIndex12502 < piListLen12502; piIndex12502++) {
      var piData12502 = piList12502[piIndex12502];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.ptIntolerances.summary(piData12502, output);
      output.append('</li>');
    }
    output.append('</ul>');
  } else if (opt_data.ptIntols.isDocumented) {
    output.append('<h4>Drug Intolerances</h4><p>');
    el8.template.ptdata.ptIntolerances.documentedAsNoneSummary(null, output);
    output.append('</p>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};
